import { BaseDTO } from './basedto';

export class AddSourceTypeDTO extends BaseDTO {
    Description: string;
    Name: string;
    IsChildLevel: number;
    ParentSourceTypeId: number;

    constructor() {
        super();
    }
}